var site = site || {};
var generic = generic || {};

(function ($, Drupal, ElcServiceBus, ServiceBusTopics) {
  /**
   * Virtual Try On landing page Formatter
   */
  Drupal.behaviors.clinicalRealityLandingFormatterV1 = {
    attach: function (context, settings) {
      const self = this;
      ServiceBusTopics = ServiceBusTopics || window.ServiceBusTopics;
      ElcServiceBus = ElcServiceBus || window.ElcServiceBus;

      var $landingVideo = $('.js-ccr-landing-video', context);
      var $landingPage = $('.js-ccr-landing-page', context);
      var $landingIframe = $('.js-ccr-landing-iframe', context);
      var $introVideo = $('.js-intro-video', context);
      var $analysisCta = $('.js-start-analysis', context);
      var $body = $('body', context);
      var $html = $('html');
      var $head = $('head', context);
      var isStartAnalysisClicked = false;
      var language = $html.attr('lang');
      var $cnContainer = $('.content_container', context);
      var isMobile = $body.hasClass('device-mobile');

      // adding class to display the intro-video & Iframe
      // in full viewport for Mobile view.
      $body.addClass('full-viewport');

      // If there is no intro video then show start analysis block
      if ($landingPage.hasClass('js-no-intro-video')) {
        displayCCRToolCta();
        document.location.hash = 'StartAnalysis';
      }

      // Display CCR tool landing content which has
      // CTA to start analysis
      function displayCCRToolCta() {
        $landingVideo.removeClass('active');
        $landingPage.addClass('active');
        $landingIframe.removeClass('active');
        $body.removeClass('full-viewport');
      }
      // Display CCR tool which has iframe embeded
      function displayCCRTool() {
        $landingVideo.removeClass('active');
        $landingPage.removeClass('active');
        $landingIframe.addClass('active');
        $body.addClass('full-viewport');
      }
      // With browser back button navigation user should
      // be able to visit different states in the quiz flow
      $(window).on('hashchange', function (event) {
        var locationObj = document.location;
        var pathName = locationObj.pathname;
        var prevURL = event?.originalEvent?.oldURL;
        var prevHashValue = '';
        var hashValue;
        var $iframes;

        if (prevURL) {
          prevURL = new URL(prevURL);
          prevHashValue = prevURL.hash;
        }

        const keywords = ['clinicalreality', 'services'];
        if (keywords.some((keyword) => pathName.includes(keyword))) {
          hashValue = locationObj.hash;

          /* 
            Corner case in which removing an element from cart (and after taking the Quiz) hashValue is reset with empty value.
            Then, an early return is needed to prevent showing landing content or an unexpected iframe reset
          */
          if (prevHashValue === '#Quiz' && hashValue === '') {
            return;
          }

          if (hashValue === '' || hashValue === '#StartAnalysis') {
            // if hash is empty or start analysis, then
            // show landing content
            displayCCRToolCta();
            // if we have progressed in the quiz, then
            // reset the iframes, otherwise don't reset
            if (isStartAnalysisClicked === true) {
              // Let's reset iframe
              $iframes = $landingIframe.children('iframe');
              $iframes.each(function () {
                $(this).attr('src', $(this).attr('data-src'));
              });
            }
          } else if (hashValue === '#Quiz') {
            // if hash is Quiz, then show quiz iframe
            displayCCRTool();
            $iframes = $landingIframe.children('iframe');
            $iframes.each(function () {
              $(this).attr('src', $(this).attr('data-src'));
            });
          }
        }
      });

      /**
       * iPad landscape mode or pc view should play 4X3 size video
       * iPad portrait mode should play 3X4 size video
       * only PC has this video switch and mobile will play its default video
       */
      var isPC = $introVideo.hasClass('js-intro-video-pc');
      // Do not show subtitle track for english language
      var $trackElement = $introVideo.children('track');
      var languageValue = language.split('-')[0];

      if (languageValue.toLowerCase().indexOf('en') > -1) {
        $trackElement.remove();
      }
      if (isPC) {
        // Utilize existing unison value
        var mediaQueryRange = $head.css('font-family');
        var $videoSource = $introVideo.children('source');

        if (mediaQueryRange.indexOf('usn-small-max') > -1) {
          // ipad portrait
          $videoSource.each(function () {
            var $thisSrc = $(this);
            var srcValue = $thisSrc.attr('data-tab-src')
              ? $thisSrc.attr('data-tab-src')
              : $thisSrc.attr('data-pc-src');

            // Load tablet specific video if available or else pc video
            $thisSrc.attr('src', srcValue);
          });
        } else if (
          mediaQueryRange.indexOf('usn-medium-max') > -1 ||
          mediaQueryRange.indexOf('usn-large-max') > -1
        ) {
          // ipad landscape and wider screen
          $videoSource.each(function () {
            var $thisSrc = $(this);

            // Load pc specific video
            $thisSrc.attr('src', $thisSrc.attr('data-pc-src'));
          });
        }
        // Since src is set using JS, we need to load the new video
        $introVideo.get(0).load();
      }

      // Display landing page when the Intro video Playback ends
      $introVideo.once().on('ended', function () {
        displayCCRToolCta();
        document.location.hash = 'StartAnalysis';
      });

      // Display WIS image IFrame when the Start analysis CTA clicked
      $analysisCta.once().on('click', function () {
        isStartAnalysisClicked = true;
        displayCCRTool();
        document.location.hash = 'Quiz';
        if (isMobile) {
          if ($landingIframe.is(':visible')) {
            $landingIframe.closest($cnContainer).addClass('clinicalreality-container');
          }
        }
      });

      // By Default removing Class in $cnContainer
      if (isMobile) {
        if (!$landingIframe.is(':visible')) {
          $landingIframe.closest($cnContainer).removeClass('clinicalreality-container');
        }
      }

      // When quiz is complete, post the data and navigate to show
      // results page
      var postIframeResults = function () {
        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        var eventer = window[eventMethod];
        var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
        eventer(
          messageEvent,
          function (event) {
            var eventData = event.data;
            var messageType = eventData.messageType;
            // Store the valid JSON response into a form and then submit
            // to view results page
            if (typeof event.data === 'object' && messageType === 'Loyalty Event') {
              // Product video can be played after quiz results
              $.cookie('ccr_product_video_played', 0, { path: '/' });
              $('.js-ccr-results-form')
                .text(JSON.stringify(event.data))
                .closest('form')
                .trigger('submit');
              var userSignedIn = parseInt(site.userInfoCookie.getValue('signed_in'));
              var isLoyaltyMember = parseInt(site.userInfoCookie.getValue('is_loyalty_member'));
              var siteUrlLoyalty = window.location.href;
              var validLoyaltyName = 'clinicalreality';

              // if the user is signed in and a loyalty member apply the Clinique Reality offer
              if (
                userSignedIn &&
                isLoyaltyMember &&
                siteUrlLoyalty.indexOf(validLoyaltyName) !== -1
              ) {
                var paramObj = {
                  offer_code: 'lyl_skin_diagnostic_reality',
                  do_not_defer_messages: 1
                };

                generic.jsonrpc.fetch({
                  method: 'offers.apply',
                  params: [paramObj]
                });
              }
            } else if (messageType === 'analytics_event') {
              // Trigger analytics event
              site.track.evtLink({
                event_name: eventData.event_name,
                event_category: eventData.event_category,
                event_action: eventData.event_action,
                event_label: eventData.event_label,
                external_session_id: eventData.external_session_id
              });
            } else if (messageType === 'analytics_pageView') {
              // Trigger analytics page view
              site.track.evtView({
                page_type: eventData.page_type,
                page_url: eventData.page_url,
                page_name: eventData.page_name,
                boutique: eventData.boutique,
                external_session_id: eventData.external_session_id
              });
            }
          },
          false
        );
      };

      // Post values from quiz data
      postIframeResults();

      // Set iframe language
      var setIframeLanguage = function () {
        var langPart = [];
        var langValue = '';
        var $iframes = $('iframe', $landingIframe);

        if (language.indexOf('-e-') > -1) {
          // for sites like ca where languages are en, fr
          langPart = language.split('-e-');
        } else if (language.indexOf('-') > -1) {
          // for site with default en language
          langPart = language.split('-');
        } else {
          // for sites like fr
          langPart.push(language);
          langPart.push(Drupal.settings.ajaxPageState.theme.split('_')[0]);
        }
        // Should in format: EnUk
        langValue = langPart.map(function (val) {
          var _val = val.toLowerCase();

          return _val.replace(_val.charAt(0), _val.charAt(0).toUpperCase());
        });

        // CCR Image iframe URL should have languages in specific format
        $iframes.each(function () {
          var $this = $(this);
          var thisSrc = $this.attr('data-src');

          if (thisSrc.indexOf('&lang=') === -1) {
            $this.attr('data-src', thisSrc + '&lang=' + langValue.join(''));
          }
        });
      };

      setIframeLanguage();

      // init iframe api capabilities
      self.initIframeResize(context);
    },
    generateLocaleSrc: function (src) {
      const mpConfig = window.MP || {
        SrcLang: 'en'
      };
      const srcParts = src.split('/');
      let iframeId = srcParts.pop();
      let locale = $.cookie('LOCALE');
      locale =
        !!locale && locale.indexOf(mpConfig.SrcLang) === -1
          ? locale.toLowerCase().replace('_', '-')
          : '';
      if (!!locale) {
        src = srcParts.join('/').concat('/').concat(locale.concat('-').concat(iframeId));
      }
      return src;
    },
    initIframeResize: function (context) {
      const self = this;
      const $iframeTemplates = $('.js-ccr-landing-iframe iframe:not(.attached)', context);

      $iframeTemplates.each(function () {
        const $this = $(this);
        let src = $this.data('src');
        if ($this.data('dynamicSrc')) {
          src = self.generateLocaleSrc(src);
        }
        $this.attr('src', src);
        $this.addClass('attached').iFrameResize({
          sizeHeight: false,
          autoResize: false,
          scrolling: true,
          heightCalculationMethod: 'bodyScroll',
          onMessage: function (response) {
            if (!response) {
              return false;
            }
            const data =
              typeof response['message'] === 'string'
                ? JSON.parse(response['message'])
                : response['message'];
            const action = data['_elc_action'];
            $this.trigger('iframe.message', [data]);
            delete data['_elc_action'];
            self.processPostMessageAction(self, $this, action, data);
          }
        });
      });
    },
    sendPostMessage: ($iframe, action, resp) => {
      $iframe.get(0).contentWindow.postMessage(
        JSON.stringify({
          ...{ _elc_action: action },
          ...resp
        }),
        '*'
      );
    },
    processPostMessageAction: async (self, $iframe, action, data) => {
      switch (action) {
        case 'addtobag':
          $(document).trigger('elc.iframe.addToBag', [$iframe, data]);
          break;
        case 'product.getProducts':
          const PRODUCT_SERVICE_IS_GRAPHQL = true;
          let productData;
          let promises = {};
          try {
            if (data.productIds) {
              let queryOptions = {
                filterBy: {
                  productIds: data.productIds
                }
              };
              if (data.queryOptions) {
                queryOptions = { ...data.queryOptions, ...queryOptions };
              }
              promises.products = ElcServiceBus.query(
                ServiceBusTopics.queries.GET_PRODUCT_DATA,
                queryOptions
              );
            }
            if (data.skuIds) {
              promises.skus = ElcServiceBus.query(ServiceBusTopics.queries.GET_SKUS, data.skuIds);
            }

            Promise.all([promises.products, promises.skus])
              .then((data) => {
                productData = {
                  _meta: {
                    graphql: PRODUCT_SERVICE_IS_GRAPHQL,
                    language: document.documentElement.getAttribute('lang'),
                    location: {
                      host: location.host,
                      pathname: location.pathname
                    }
                  },
                  products: data[0],
                  skus: data[1]
                };
              })
              .catch((e) => {
                productData = e;
              })
              .finally(() => {
                self.sendPostMessage($iframe, action, productData);
              });
          } catch (e) {
            console.log(e);
          }
          break;
      }
    }
  };
})(jQuery, Drupal, window.ElcServiceBus || false, window.ServiceBusTopics || false);
